import { Action } from '@ngrx/store';
import { USTreasury } from '../../types/treasuries.types';

export enum USTreasuriesActionTypes {
  Load = '[USTreasuries] Load',
  LoadSuccess = '[USTreasuries] Load Success',
  LoadFail = '[USTreasuries] Load Fail'
}

export class LoadUSTreasuries implements Action {
  public readonly type = USTreasuriesActionTypes.Load;

  constructor(public payload: { date: string }) {}
}

export class LoadUSTreasuriesSuccess implements Action {
  public readonly type = USTreasuriesActionTypes.LoadSuccess;
  constructor(public payload: USTreasury[]) {}
}

export class LoadUSTreasuriesFail implements Action {
  public readonly type = USTreasuriesActionTypes.LoadFail;

  constructor(public payload: string) {}
}
export type USTreasuriesActionsUnion =
  | LoadUSTreasuries
  | LoadUSTreasuriesSuccess
  | LoadUSTreasuriesFail;
